<!-- <app-header [isMobile]="isMobile"></app-header> -->
<!-- <div class="headerSpacer"></div> -->

<div class="mspPage">
    <!-- Background --> 
    <div class="bgRowsCover"></div>
    <div class="bgRows">
        <div class="bgRowsHalf">
            <app-poster-bg-3row [posters]="postersRow1" [isMobile]="isMobile"></app-poster-bg-3row>
        </div>
        <div class="bgRowsHalf">
            <app-poster-bg-3row [posters]="postersRow2" [isReversed]="true" [isMobile]="isMobile"></app-poster-bg-3row>
        </div>
    </div>
    <div class="bgRowsCover2"></div>


    <!-- Social icons — top right (desktop only) -->
    <div class="socialIcons" *ngIf="!isMobile">
        <a href="https://www.instagram.com/moviesphere" target="_blank" class="socialIcon">
            <img src="assets/img/moviesphere-plus/instagram.png" class="normal" alt="Instagram">
            <img src="assets/img/moviesphere-plus/instagram-rollover.png" class="over" alt="">
        </a>
        <a href="https://www.facebook.com/MovieSphereOfficial/" target="_blank" class="socialIcon">
            <img src="assets/img/moviesphere-plus/facebook.png" class="normal" alt="Facebook">
            <img src="assets/img/moviesphere-plus/facebook-rollover.png" class="over" alt="">
        </a>
        <a href="https://www.tiktok.com/@moviespheretv" target="_blank" class="socialIcon">
            <img src="assets/img/moviesphere-plus/tik-tok.png" class="normal" alt="TikTok">
            <img src="assets/img/moviesphere-plus/tik-tok-rollover.png" class="over" alt="">
        </a>
        <a href="https://x.com/moviesphere" target="_blank" class="socialIcon">
            <img src="assets/img/moviesphere-plus/x.png" class="normal" alt="X">
            <img src="assets/img/moviesphere-plus/x-rollover.png" class="over" alt="">
        </a>
    </div>

    <!-- Main content -->
    <div class="content">
        <img src="assets/img/moviesphere-plus/moviesphere-plus-logo-gradient-desktop.png" class="logo" alt="MovieSphere+">

        <img *ngIf="!isMobile" src="assets/img/moviesphere-plus/Hit-Movies-Cult-Classics-ad-free-on-demand-desktop.png" class="headline" alt="Hit Movies. Cult Classics. Ad-free. On demand.">
        <img *ngIf="isMobile" src="assets/img/moviesphere-plus/mobile/Hit-Movies-Cult-Classics-ad-free-on-demand-mobile.png" class="headline" alt="Hit Movies. Cult Classics. Ad-free. On demand.">

        <a href="https://www.amazon.com/gp/video/channel/5b5d8c9f-01f7-4916-b20f-53ea0a51b51e" target="_blank" class="rolloverBtn trialBtn">
            <img src="assets/img/moviesphere-plus/start-your-free-trial-button-desktop.png" class="normal" alt="Start Your Free Trial">
            <img src="assets/img/moviesphere-plus/start-your-free-trial-button-rollover-desktop.png" class="over" alt="">
        </a>

        <a href="https://www.amazon.com/gp/video/channel/5b5d8c9f-01f7-4916-b20f-53ea0a51b51e" target="_blank" class="rolloverBtn pricingBtn">
            <img *ngIf="!isMobile" src="assets/img/moviesphere-plus/4-99-month.png" class="normal" alt="$4.99 / month">
            <img *ngIf="isMobile" src="assets/img/moviesphere-plus/mobile/4-99-month.png" class="normal" alt="$4.99 / month">
            <img src="assets/img/moviesphere-plus/4-99-month-rollover.png" class="over" alt="">
        </a>
        <!-- <span class="rolloverBtn pricingBtn" (click)="openPromo()">
            <img *ngIf="!isMobile" src="assets/img/moviesphere-plus/promo/0-99-month-moviesphere-plus.png" class="normal" alt="only $0.99 / month for 2 months">
            <img *ngIf="isMobile" src="assets/img/moviesphere-plus/promo/0-99-month-moviesphere-plus-mobile.png" class="normal" alt="only $0.99 / month for 2 months">
            <img src="assets/img/moviesphere-plus/promo/0-99-month-moviesphere-plus-rollover.png" class="over" alt="">
        </span> -->

        <div class="bottomBar">
            <div class="availableOn">
                <span class="availableLabel">AVAILABLE ON:</span>
                <div class="platforms">
                    <a href="https://www.amazon.com/gp/video/channel/5b5d8c9f-01f7-4916-b20f-53ea0a51b51e" target="_blank" class="rolloverBtn platformBtn">
                        <img src="assets/img/moviesphere-plus/prime-video-button-desktop.png" class="normal" alt="Prime Video">
                        <img src="assets/img/moviesphere-plus/prime-video-button-rollover-desktop.png" class="over" alt="">
                    </a>
                    <a href="https://www.youtube.com/@MovieSphereChannel/featured" target="_blank" class="rolloverBtn platformBtn">
                        <img src="assets/img/moviesphere-plus/youtube-button-desktop.png" class="normal" alt="YouTube">
                        <img src="assets/img/moviesphere-plus/youtube-button-rollover-desktop.png" class="over" alt="">
                    </a>
                </div>
            </div>

            <div class="emailUpdates" *ngIf="!isMobile" (click)="onClick()">
                <span class="emailLabel">EMAIL UPDATES</span>
                <span class="rolloverBtn emailBtn">
                    <img src="assets/img/moviesphere-plus/email.png" class="normal" alt="Email Updates">
                    <img src="assets/img/moviesphere-plus/email-rollover.png" class="over" alt="">
                </span>
            </div>
        </div>
    </div>
</div>

<!-- Mobile bottom bar: follow + email + logo (mobile only) -->
<div class="mobileBottom" *ngIf="isMobile">
    <div class="mobileBottomRow">
        <div class="mobileFollowSection">
            <span class="mobileLabel">FOLLOW MOVIESPHERE+</span>
            <div class="mobileSocialIcons">
                <a href="https://www.instagram.com/moviesphere" target="_blank" class="socialIcon">
                    <img src="assets/img/moviesphere-plus/instagram.png" class="normal" alt="Instagram">
                    <img src="assets/img/moviesphere-plus/instagram-rollover.png" class="over" alt="">
                </a>
                <a href="https://www.facebook.com/MovieSphereOfficial/" target="_blank" class="socialIcon">
                    <img src="assets/img/moviesphere-plus/facebook.png" class="normal" alt="Facebook">
                    <img src="assets/img/moviesphere-plus/facebook-rollover.png" class="over" alt="">
                </a>
                <a href="https://x.com/moviesphere" target="_blank" class="socialIcon">
                    <img src="assets/img/moviesphere-plus/x.png" class="normal" alt="X">
                    <img src="assets/img/moviesphere-plus/x-rollover.png" class="over" alt="">
                </a>
                <a href="https://www.tiktok.com/@moviespheretv" target="_blank" class="socialIcon">
                    <img src="assets/img/moviesphere-plus/tik-tok.png" class="normal" alt="TikTok">
                    <img src="assets/img/moviesphere-plus/tik-tok-rollover.png" class="over" alt="">
                </a>
            </div>
        </div>
        <div class="mobileEmailSection" (click)="onClick()">
            <span class="mobileLabel">EMAIL UPDATES</span>
            <span class="rolloverBtn mobileEmailBtn">
                <img src="assets/img/moviesphere-plus/email.png" class="normal" alt="Email Updates">
                <img src="assets/img/moviesphere-plus/email-rollover.png" class="over" alt="">
            </span>
        </div>
    </div>
    <div class="mobileLogoRow">
        <img src="assets/img/moviesphere-plus/moviesphere-plus-white-logo-footer.png" alt="MovieSphere+">
    </div>
    <app-footer *ngIf="isMobile"></app-footer>
</div>

<div class="desktopFooterLogo" *ngIf="!isMobile">
    <img src="assets/img/moviesphere-plus/moviesphere-plus-white-logo-footer.png" alt="MovieSphere+">
</div>
<app-footer *ngIf="!isMobile"></app-footer>
<app-updates-page></app-updates-page>
